var map = {
	"./en/common.json": [
		54749,
		4749
	],
	"./en/superadmin.json": [
		37646,
		7646
	],
	"./fr/common.json": [
		24480,
		4480
	],
	"./fr/superadmin.json": [
		53727,
		3727
	],
	"./np/common.json": [
		45506,
		5506
	],
	"./np/superadmin.json": [
		19909,
		9909
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64766;
module.exports = webpackAsyncContext;